export const proteinColorSchemes = {
    dssp8: {
        primary : {
            // placeholder
            '+':'#ededed',

            'G':'#ededed',
            'H':'#ededed',
            'I':'#ededed',
            'B':'#ededed',
            'E':'#ededed',
            'S':'#ededed',
            'T':'#ededed',
            'C':'#ededed',
        },
        contrast : {
            // placeholder
            '+':'#ededed',

            'G':'#8ad970',
            'H':'#ccd96a',
            'I':'#d99657',
            'B':'#d95633',
            'E':'#d958aa',
            'S':'#6d3bd9',
            'T':'#3f54d9',
            'C':'#4cd9c2',
        }
    },
    disorder: {
        primary : {
            // placeholder
            '+':'#ededed',

            '-':'#ededed',
            'X':'#505050',
        },
        contrast : {
            // placeholder
            '+':'#ededed',

            '-':'#ededed',
            'X':'#505050',
        }
    },
    mview: {
        primary : {
            // placeholder
            '+':'#ededed',

            '.':'#fafafa',
            '-':'#fafafa',
            'G':'#33cc00',
            'A':'#33cc00',
            'I':'#33cc00',
            'V':'#33cc00',
            'L':'#33cc00',
            'M':'#33cc00',
            'F':'#009900',
            'Y':'#009900',
            'W':'#009900',
            'H':'#009900',
            'C':'#ffff00',
            'P':'#33cc00',
            'K':'#cc0000',
            'R':'#cc0000',
            'D':'#0033ff',
            'E':'#0033ff',
            'Q':'#6600cc',
            'N':'#6600cc',
            'S':'#0099ff',
            'T':'#0099ff',
            'B':'#666666',
            'Z':'#666666',
            'X':'#666666',
            '?':'#999999',
            '*':'#666666',
            'U':'#000000'
        },
        contrast : {
            // placeholder
            '+':'#ededed',

            '.':'#fafafa',
            '-':'#fafafa',
            'G':'#fafafa',
            'A':'#fafafa',
            'I':'#fafafa',
            'V':'#fafafa',
            'L':'#fafafa',
            'M':'#fafafa',
            'F':'#fafafa',
            'Y':'#fafafa',
            'W':'#fafafa',
            'H':'#fafafa',
            'C':'#505050',
            'P':'#fafafa',
            'K':'#fafafa',
            'R':'#fafafa',
            'D':'#fafafa',
            'E':'#fafafa',
            'Q':'#fafafa',
            'N':'#fafafa',
            'S':'#fafafa',
            'T':'#fafafa',
            'B':'#fafafa',
            'Z':'#fafafa',
            'X':'#fafafa',
            '?':'#fafafa',
            '*':'#fafafa',
            'U':'#fafafa'
        }
    },
};